const AppLifecycle = {}

AppLifecycle.ready = function(queuedFunction) {
  window.setTimeout(() => {
    // for async loading of the main script
    if (document.readyState !== 'loading') {
      queuedFunction()
    }
    document.addEventListener('turbolinks:load', queuedFunction)
  })
}

AppLifecycle.destroy = function(queuedFunction) {
  document.addEventListener('turbolinks:before-render', queuedFunction)
}

AppLifecycle.loadScript = function(src) {
  return new Promise(function(resolve, reject) {
    let scripts = Array.from(document.querySelectorAll('script')).map(
      scr => scr.src
    )

    if (scripts.includes(src)) {
      resolve()
      return
    }

    const s = document.createElement('script')
    s.src = src
    s.async = true
    s.onload = resolve
    s.onerror = reject
    document.head.appendChild(s)
  })
}

AppLifecycle.serveTrackingTags = function() {
  return document.body.getAttribute('data-serve-tracking-tags') === 'True'
}

AppLifecycle.initJS = function(target) {
  M.AutoInit(target)

  const datepickerElements = $('.datepicker')
  const instances = M.Datepicker.init(datepickerElements, {
    setDefaultDate: true,
    firstDay: 1,
    showDaysInNextAndPreviousMonths: true,
    container: 'body'
  })

  const datepickerModalElements = $('.datepicker-modal')
  M.Modal.init(datepickerModalElements, {
    dismissible: false
  })

  for (let i = 0; i < instances.length; i++) {
    instances[i].el.addEventListener('select', () => {
      instances[i].open()
    })
  }

  initComponentsAfterLoad()

  setTimeout(() => {
    M.updateTextFields()
  }, 100)

  // If some scripts have been appended and want to be loaded, execute them on the fly.
  if (target) {
    $(target)
        .find('script[data-app-lifecycle-load="true"]')
        .each(function (index, script) {
          eval($(script).text())
        });
  }

  // TODO find a better place?
  let selected_language_code = document.querySelector('#selected_language_code')
  if(selected_language_code) {
    let params = new URL(document.location.href).searchParams;
    let language_code = params.get('language_code')
    if(language_code) {
      selected_language_code.value = language_code
    }

    selected_language_code.addEventListener('change', (event) => {
      let url = new URL(document.location.href);
      url.searchParams.set('language_code', event.target.value)
      document.location.href = url
    });  
  }

  if(target) {
    let SHORT_NAME_MAX_LENGTH = 25; // TODO define centrally
    let name_element = target.querySelector("#id_name");
    let short_name_element = target.querySelector("#id_short_name");

    if(name_element && short_name_element) {
      let helper_text_element = name_element.parentElement.parentElement.querySelector(".helper-text");

      let event_listener = (e) => { 
        if(name_element.value.length > SHORT_NAME_MAX_LENGTH)
          helper_text_element.innerText = "Name is longer than " + SHORT_NAME_MAX_LENGTH + " characters. Please consider filling the Short Name field, too."; 
        else helper_text_element.innerText = "";  
      };

      name_element.addEventListener("change", event_listener);
      name_element.addEventListener("keypress", event_listener);
      name_element.addEventListener("paste", event_listener);
      name_element.addEventListener("input", event_listener);
    }
  }
}

export default AppLifecycle
